import React, { useEffect, useState } from "react";
import logo from "../../assets/img/logo.webp";
import { HashLink } from "react-router-hash-link";
import { useNavigate } from "react-router";
import stellenanzeige from "../../assets/img/Stellenanzeige.webp";
import infoDoc from "../../assets/pdf/Stellenanzeige_Ergo.pdf";

function PopUp() {
  const [showPopUp, setShowPopUp] = useState(true);

  let navigate = useNavigate();

  useEffect(() => {
    if (window.sessionStorage.getItem("popUpShown")) {
      setShowPopUp(false);
    }
  }, []);

  const closePopUp = () => {
    setShowPopUp(false);
    window.sessionStorage.setItem("popUpShown", true);
  };

  const linkToPage = () => {
    setShowPopUp(false);
    window.sessionStorage.setItem("popUpShown", true);
    navigate("/ernährungsberatung");
  };

  const downloadFile = () => {
    window.open(infoDoc, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="popup-wrapper" data-type={showPopUp ? "show" : ""}>
      <div className="popup-window">
        <div className="popup-header">
          <div className="popup-close-btn" onClick={() => closePopUp()}>
            <span>x</span>
          </div>
        </div>
        <div className="popup-content">
          <h4 className="popup-content-header">
            Therapie auf neuem Level: Ergotherapeut:in (m/w/d) gesucht!
          </h4>
          <img
            className="popup-content-image"
            src={stellenanzeige}
            alt="Stellenanzeige"
          />
          <div className="popup-content-items">
            <p className="popup-content-text">
              Du willst nicht nur „einfach mitarbeiten“, sondern suchst einen
              Ort, der deine Expertise schätzt und dir den Rücken freihält? Dann
              komm zum <span className="fw-bold">Hauptsitz von Epikur</span>{" "}
              nach Falkenberg. Seit 2005 stehen wir für Beständigkeit – und
              jetzt setzen wir noch eins drauf!
            </p>
            <p className="popup-content-text">
              Für weitere Informationen klicke auf die Schaltfläche unten.
            </p>
          </div>

          <div onClick={() => downloadFile()} className="btn">
            Stellenanzeige herunterladen
          </div>
        </div>
      </div>
      <div className="popup-bg" onClick={() => closePopUp()}></div>
    </div>
  );
}

export default PopUp;
